import { NgModule } from '@angular/core';
// application-pipes.module.ts
// other imports
import {
  CapitalizeWords,
  DashWords,
  UnderscoreWords,
  Moment,
  PhoneNumber,
  SafePipe,
  Month,
  EscapeHtmlPipe,
  Has,
  IsInGroup,
  IsAccount,
  IsUser,
  IsMobile,
  IsDesktop,
  SplitPipe,
} from './directives/application-pipes.directive';

@NgModule({
  imports: [
    // dep modules
  ],
  declarations: [
    SafePipe,
    CapitalizeWords,
    DashWords,
    UnderscoreWords,
    PhoneNumber,
    Moment,
    Month,
    EscapeHtmlPipe,
    Has,
    IsInGroup,
    IsAccount,
    IsUser,
    IsMobile,
    IsDesktop,
    SplitPipe,
  ],
  exports: [
    SafePipe,
    CapitalizeWords,
    PhoneNumber,
    Moment,
    Month,
    EscapeHtmlPipe,
    Has,
    IsInGroup,
    IsAccount,
    IsUser,
    IsMobile,
    IsDesktop,
    DashWords,
    UnderscoreWords,
    SplitPipe,
  ],
})
export class ApplicationPipesModule {}
